var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gofixSplit"},[_c('div',{staticClass:"splitItem splitLeft"},[_vm._t("gofixSplit:left")],2),_c('div',{staticClass:"splitControl"}),_c('div',{staticClass:"splitItem splitRight"},[_vm._t("gofixSplit:right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }